document.querySelectorAll('.rp-testi__splide').forEach(function(el) {
  var sectionEl = el.closest('.rp-testi');
  if (!sectionEl) return;

  var splide = new Splide(el, {
    type      : 'loop',
    perPage   : 1,
    arrows    : false,
    pagination: false,
    /* autoHeight TOUJOURS actif (desktop + mobile) : chaque slide prend
       exactement sa propre hauteur naturelle. On avait désactivé ça sur
       mobile pour aligner .rp-testi__actions en bas via margin-top:auto,
       mais la hauteur "commune" calculée par Splide (mesurée au montage,
       avant chargement complet des images / avec des titres de longueur
       variable) pouvait être trop courte et TRONQUER le texte de certains
       témoignages sans "…" visible. La lisibilité du texte prime sur
       l'alignement uniforme des boutons. */
    autoHeight: true,
    gap       : 0,
    speed     : 500,
  });

  splide.mount();

  /* Les flèches sont rendues dans chaque slide (et dupliquées par les clones
     du mode "loop") : on lie donc TOUTES les occurrences. */
  sectionEl.querySelectorAll('.rp-testi__prev').forEach(function(btn) {
    btn.addEventListener('click', function() { splide.go('<'); });
  });
  sectionEl.querySelectorAll('.rp-testi__next').forEach(function(btn) {
    btn.addEventListener('click', function() { splide.go('>'); });
  });
});
